import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { config } from "core/config/app";
import { deviceStorage } from "core/utils/devicestorage";
import { fetchMe, loginRequest, resetLogin, updateFormSignUp,updateFormSave } from "../store/actions";
import { useFailed, useSuccess } from "core/utils/utils";

export function useFetchMe() {
  const dispatch = useDispatch();
  const token = deviceStorage[
    localStorage.getItem("storage_driver") || "session"
  ].getItem(config.appPackage + "_X_TOKEN");
  useEffect(() => {
    if (token) {
      dispatch(fetchMe());
    }
    // eslint-disable-next-line
  }, []);
}

export function useLoginClient(form: any) {
  const loginSelector = useSelector((state: any) => state.Auth || {});
  const dispatch = useDispatch();
  const handleSubmitLogin = (data: any) => {
    dispatch(loginRequest(data));
  };

  const failCallback = (e: any) => {
    if (e.errors) {
      // formValidateApi(form, e)
    } else {
      // eslint-disable-next-line no-constant-condition
      if (e.code === 401 || 500) {
        // form.setError('username', { message: e.msg })
        form.onFailed(e)
      }
    }
  }

  const successCallback = () => {
    //console.log('successCallback');
    
    form.onSuccess(loginSelector);
  }

  useSuccess(loginSelector.loginSuccess, 'Login Success',successCallback)
  useFailed(loginSelector.loginFailed, 'Login Failed', failCallback);

  return {handleLogin:handleSubmitLogin};
}

export const useResetLogin = () => {
  // useResetState(resetLoginState);
  //console.log('useResetLogin');
  const dispatch = useDispatch();
  // useEffect(() => {
  //   return () => {
  //     dispatch(resetLogin({}));
  //   };
  // }, [dispatch]);

  const handleResetLogin = () => {
    //console.log('handleResetLogin');
    
    dispatch(resetLogin({}));
  }

  return handleResetLogin
};

export function useUser() {
  const auth = useSelector((state: any) => state.Auth);
  const user = { userInfo: auth?.userInfo, setting: auth?.setting };
  return user;
}

export function useUpdateFormSignUp(data: any) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateFormSignUp(data));
  }, [data, dispatch]);
}
export function useFormSignUp() {
  const dataSignUp = useSelector((state: any) => state.Auth);
  const dataForm = dataSignUp?.dataFormSignUp;
  return dataForm;
}

export function useIdleTime() {
  const data = useSelector((state: any) => state.Auth);
  const dataTime = data?.idleTime;
  return dataTime;
}

export function useTimeResume() {
  const data = useSelector((state: any) => state.Auth);
  const dataTime = data?.timeResume;
  return dataTime;
}

export function useUpdateFormSave(data: any) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateFormSave(data));
  }, [data, dispatch]);
}

export function useDataFormSave() {
  const dataFormSave = useSelector((state: any) => state.Auth);
  const dataForm = dataFormSave?.dataForm;
  return dataForm;
}

export function useGetLang() {
  const appSettings = useSelector((state: any) => state.AppSettings?.data || []);
  const langCodeCurrent = (window as any)._APP_LANG
  let langCurrent = {
    langCode:'',
    langId:''
  }
  appSettings?.languages?.forEach((item: any) => {
    if (item.code === langCodeCurrent) {
      langCurrent = {
        langCode: item.code,
        langId: item.id
      };
    }
  });
  return {
    langCode:langCurrent?.langCode,
    langId:langCurrent?.langId
  }
}

export const useIsAuth = () => {
  const isAuth = useSelector((state: any) => state.Auth?.token);
  return isAuth;
}
